// src/utils/scrollToTop.js
export const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); // or use 'smooth' for a smoother transition
  };
  